import React, { useState, useCallback, useRef, useEffect } from 'react';
import Cropper from 'react-easy-crop';
import PropTypes from 'prop-types';
import getCroppedImg from './CropImage';
import './crop.css';

const Crop = ({ image, validerCropImage, handleRecupererImageCroppe }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [showZoomHint, setShowZoomHint] = useState(false);
    const [showMultiTouchHint, setShowMultiTouchHint] = useState(false);
    const [removeTouchAction, setRemoveTouchAction] = useState(false);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const zoomTimeoutRef = useRef();
    const touchTimeoutRef = useRef();

    useEffect(() => {
        clearTimeout(zoomTimeoutRef.current);
        clearTimeout(touchTimeoutRef.current);
    }, []);

    const onCropComplete = useCallback((croppedArea, croppedAreaPixel) => {
        setCroppedAreaPixels(croppedAreaPixel);
    }, []);

    useEffect(() => {
        try {
            if (croppedAreaPixels) {
                const getCropImagee = async () => {
                    const cropImage = await getCroppedImg(image, croppedAreaPixels);
                    handleRecupererImageCroppe(cropImage);
                };
                getCropImagee();
            }
        } catch (e) {
            handleRecupererImageCroppe(e);
        }
    }, [validerCropImage]);

    const onWheelRequest = (e) => {
        // require the CTRL/⌘ key to be able to zoom with wheel
        if (e.ctrlKey || e.metaKey) {
            setShowZoomHint(false);
            return true;
        }
        setShowZoomHint(true);
        clearTimeout(zoomTimeoutRef.current);
        zoomTimeoutRef.current = setTimeout(() => setShowZoomHint(false), 2000);
        return false;
    };
    const onTouchRequest = (e) => {
        // require 2 fingers to be able to interact with the image
        if (e.touches.length > 1) {
            setShowMultiTouchHint(false);
            setRemoveTouchAction(true);
            return true;
        }
        setShowMultiTouchHint(true);
        setRemoveTouchAction(false);
        clearTimeout(touchTimeoutRef.current);
        touchTimeoutRef.current = setTimeout(() => setShowMultiTouchHint(false), 2000);
        return false;
    };

    return (
        <div>
            <div className="cropContainer">
                <Cropper
                    image={image}
                    crop={crop}
                    zoom={zoom}
                    aspect={7 / 9}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                    onWheelRequest={onWheelRequest}
                    onTouchRequest={onTouchRequest}
                    classes={removeTouchAction && { containerClassName: 'removeTouchAction' }}
                />
                {showZoomHint && (
                    <div className="zoom-hint">
                        <p>Utiliser ⌘ + scroll (or ctrl + scroll) pour zoomer sur l&acute;image</p>
                    </div>
                )}
                {showMultiTouchHint && (
                    <div className="touch-hint">
                        <p>Utiliser 2 doigts pour interagir avec l&acute;image</p>
                    </div>
                )}
            </div>
            <div className="controls">
                <input
                    type="range"
                    value={zoom}
                    min={1}
                    max={3}
                    step={0.1}
                    aria-labelledby="Zoom"
                    onChange={(e) => {
                        setZoom(e.target.value);
                    }}
                    className="zoom-range"
                />
            </div>
        </div>
    );
};

Crop.propTypes = {
    image: PropTypes.string.isRequired,
    validerCropImage: PropTypes.bool,
    handleRecupererImageCroppe: PropTypes.func,
};

export default Crop;
